module.exports = __webpack_public_path__ + "static/media/milkyway.fd415b8e.mp4";